var exports = {
  "k": "container__FmMUNJ",
  "q": "imageElement__Pr5bJ5",
};

module.exports = exports;
